import { NOT_SET, track } from '@/src/utils/tracking';

const EVENT_TYPES = {
  SWIMLANE_SWIPED: 'swimlane_swiped',
  SHOP_CLICKED: 'shop_clicked',
  PRODUCT_CLICKED: 'product_clicked',
};

const DEFAULT_ORIGIN_QC = 'item-landing-qc';

const quickCommerceEvents = {
  [NOT_SET]: () => {
    console.info('Need to assert tracking event');
  },
  [EVENT_TYPES.SWIMLANE_SWIPED]: ({
    vendors = [],
    position = 0,
    productsIds = [],
  }) => {
    const vendor = vendors[position];
    const swimlaneContent = productsIds
      ?.flat()
      ?.map((id) => id || '')
      .join(',');

    track(
      EVENT_TYPES.SWIMLANE_SWIPED,
      {
        screenType: DEFAULT_ORIGIN_QC,
        shopId: vendor?.id,
        swimlaneContent,
        swimlanePosition: productsIds?.flat()?.length,
        swimlaneType: 'product',
      },
      {
        logEventKey: `[${EVENT_TYPES.SWIMLANE_SWIPED}]`,
        sendToLogs: true,
      },
    );
  },
  [EVENT_TYPES.SHOP_CLICKED]: ({ vendor = {} }) => {
    track(
      EVENT_TYPES.SHOP_CLICKED,
      {
        shopClickOrigin: DEFAULT_ORIGIN_QC,
        shopId: vendor?.id,
        screenType: DEFAULT_ORIGIN_QC,
      },
      {
        logEventKey: `[${EVENT_TYPES.SHOP_CLICKED}]`,
        sendToLogs: true,
      },
    );
  },
  [EVENT_TYPES.PRODUCT_CLICKED]: ({ product = {}, vendor = {}, origin }) => {
    const productIndex = vendor?.products?.findIndex(
      (vendo) => vendo.id === product.id,
    );

    track(
      EVENT_TYPES.PRODUCT_CLICKED,
      {
        origin,
        shopId: vendor?.id,
        productIndex,
        productSku: product?.id,
        productUnitPrice: product?.pricing?.beforePrice,
        productUnitSalePrice: product?.pricing?.price,
        screenType: DEFAULT_ORIGIN_QC,
      },
      {
        logEventKey: `[${EVENT_TYPES.PRODUCT_CLICKED}]`,
        sendToLogs: true,
      },
    );
  },
};

export const quickCommerce = ({ type = NOT_SET, payload = NOT_SET }) =>
  quickCommerceEvents[type]
    ? quickCommerceEvents[type](payload)
    : quickCommerceEvents[NOT_SET]();
